import React, {useEffect, useRef, useState} from "react";
import constants from "../../../../config/constants";
import axios from "axios";
import Button from "@mui/material/Button";


export const RankingPage = ({setRankingDisplay}) => {

    const [ranking, setRanking] = useState([]);
    const initialFetch = useRef(false);

    useEffect(() => {
        if (!initialFetch.current) {
            axios.get(constants.api.basePath + "/anniv2025/classement").then(res => {
                setRanking(res.data.rankedUsers);
            });
            initialFetch.current = true;
        }
    }, []);

    return (
        <div style={{padding: "20%", paddingTop: "15px", color: "white"}}>
            <h1>Classement</h1>
            <div>
                <table style={{width: "100%", borderCollapse: "collapse"}}>
                    <thead>
                    <tr>
                        <th style={{borderBottom: "1px solid #ddd", padding: "8px", textAlign: "left"}}>#</th>
                        <th style={{borderBottom: "1px solid #ddd", padding: "8px", textAlign: "left"}}>Equipe</th>
                        <th style={{borderBottom: "1px solid #ddd", padding: "8px", textAlign: "left"}}>Progrès</th>
                    </tr>
                    </thead>
                    <tbody>
                    {ranking.map((user, index) => (
                        <tr key={user.username}>
                            <td style={{padding: "8px"}}>{index + 1}</td>
                            <td style={{padding: "8px"}}>{user.username}</td>
                            <td style={{padding: "8px"}}>{user.progress} %</td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
            <div style={{textAlign: "center", marginTop: "3vh"}}>
                <Button variant="contained" type="submit" onClick={() => setRankingDisplay(false)}>
                    Retour
                </Button>
            </div>
        </div>
    );
}
